
import React, { useState } from "react";
import { Search, Grid, Clock, List, ChevronDown, ChevronRight, Building2, Package, Factory, Truck, Link2, ShoppingBag, Globe } from "lucide-react";
import ModalPop from "./ModalPop";
import AddModal from "./AddModal";
import { Shield } from 'lucide-react';
import { CircleCheck } from 'lucide-react';


const GlossaryDiscovery = () => {
  const [viewMode, setViewMode] = useState("list");
  const [expandedItems, setExpandedItems] = useState({ "l1": true, "l2": true, "l3": true, "l4": true, "l4-2": true, "l5": true, "l5-2": true, "l6": true, "l6-2": true });
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [glossaryTerms, setGlossaryTerms] = useState([
    {
      id: 1,
      term: "Bias",
      status: "Approved",
      definition: "A systematic tendency in forecasts to consistently over-predict or under-predict actual demand over time.",
      owner: "Sarah Chen",
      classification: "Internal",
      date: "2024-01-30"
    },
    {
      id: 2,
      term: "Category Performance",
      status: "Approved",
      definition: "An analysis of sales share, and growth metrics for a product category within a defined market or retailer.",
      owner: "Chris Anderson",
      classification: "Confidential",
      date: "2024-03-18"
    },
    {
      id: 3,
      term: "Consensus Forecast",
      status: "Approved",
      definition: "A demand forecast that integrates inputs from multiple functional areas including sales, marketing, finance, and supply chain.",
      owner: "James Wilson",
      classification: "Confidential",
      date: "2024-02-01"
    },
    {
      id: 4,
      term: "Days of Supply (DOS)",
      status: "Approved",
      definition: "The number of days current inventory will last based on average daily demand or consumption rate.",
      owner: "James Wilson",
      classification: "Internal",
      date: "2024-01-22"
    },
    {
      id: 5,
      term: "Demand Forecast",
      status: "Approved",
      definition: "A projection of future customer demand based on historical data, market trends, and statistical models to guide production and invento...",
      owner: "Sarah Chen",
      classification: "Confidential",
      date: "2024-09-15"
    },
    {
      id: 6,
      term: "Demand Variability",
      status: "Approved",
      definition: "The degree of fluctuation in customer demand over time, measured as coefficient of variation or standard deviation of demand.",
      owner: "Sarah Chen",
      classification: "Internal",
      date: "2024-01-18"
    },
    {
      id: 7,
      term: "Distribution (ACV)",
      status: "Approved",
      definition: "All Commodity Volume - the percentage of total store sales volume where a product is available.",
      owner: "Chris Anderson",
      classification: "Internal",
      date: "2024-03-10"
    },
    {
      id: 8,
      term: "Forecast Accuracy",
      status: "Approved",
      definition: "A measurement of how closely the demand forecast matches actual sales, typically expressed as a percentage comparing forecasted vs...",
      owner: "Sarah Chen",
      classification: "Internal",
      date: "2024-01-15"
    },
    {
      id: 9,
      term: "Inventory Turns",
      status: "Approved",
      definition: "A ratio showing how many times inventory is sold and replaced over a period, indicating inventory efficiency.",
      owner: "James Wilson",
      classification: "Internal",
      date: "2024-01-05"
    },
    {
      id: 10,
      term: "Market Share",
      status: "Approved",
      definition: "The percentage of total category sales captured by Mars Wrigley products in a defined market or channel.",
      owner: "Chris Anderson",
      classification: "Confidential",
      date: "2024-03-05"
    },
    {
      id: 11,
      term: "Mean Absolute Percentage Error (MAPE)",
      status: "Approved",
      definition: "A measure of prediction accuracy that expresses error as a percentage, calculated as the average of absolute percentage errors.",
      owner: "Sarah Chen",
      classification: "Internal",
      date: "2024-08-10"
    }
  ]);

  const levelStyles = {
    0: "text-gray-400",                 // L1
    1: "text-green-400",                // L2
    2: "text-cyan-400",                 // L3
    3: "text-yellow-400",               // L4
    4: "text-red-400",                  // L5
    5: "text-pink-400",                 // L6
    6: "text-blue-400",                 // L7
  };

  const hierarchyData = [
    {
      id: "l1",
      name: "Mars Inc",
      icon: Building2,
      children: [
        {
          id: "l2",
          name: "Snacking",
          icon: Package,
          children: [
            {
              id: "l3",
              name: "Mars Wrigley",
              icon: Factory,
              children: [
                {
                  id: "l4",
                  name: "Supply",
                  icon: Truck,
                  children: [
                    {
                      id: "l5",
                      name: "E2E Supply Chain",
                      icon: Link2,
                      children: [
                        {
                          id: "l6",
                          name: "EU",
                          icon: Globe,
                          children: [
                            { id: "l7", name: "Da...", icon: null, count: 10 }
                          ]
                        }
                      ]
                    },
                    {
                      id: "l4-2",
                      name: "One Demand",
                      icon: Truck,
                      children: [
                        {
                          id: "l5-2",
                          name: "Sales",
                          icon: ShoppingBag,
                          children: [
                            {
                              id: "l6-2",
                              name: "North America",
                              icon: Globe,
                              children: [
                                { id: "l7-2", name: "Ret...", icon: null, count: 10 }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ];

  const toggleExpand = (id) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleAddTerm = (newTermData) => {
    const newTerm = {
      id: glossaryTerms.length + 1,
      term: newTermData.term,
      status: newTermData.status,
      definition: newTermData.definition,
      owner: newTermData.owner,
      classification: newTermData.classification,
      date: new Date().toISOString().split('T')[0],
      fullDefinition: newTermData.definition,
      formula: newTermData.formula,
      department: newTermData.department,
      certificate: newTermData.certificate,
      businessContext: newTermData.businessContext,
      dataType: newTermData.dataType,
      source: newTermData.source,
      tags: newTermData.tags
    };

    setGlossaryTerms([...glossaryTerms, newTerm]);
  };

  const renderHierarchyItem = (item, level = 0) => {

    const isExpanded = expandedItems[item.id];

    const hasChildren = item.children && item.children.length > 0;

    const Icon = item.icon;

    // Define icon colors for each level

    const levelColors = {

      0: { text: "#a17ef4" },  // L1

      1: { text: "#5491f5" },  // L2

      2: { text: "#16a34a" },  // L3 (green-600)

      3: { text: "#78350f" },  // L4

      4: { text: "#f4af3c" },  // L5

      5: { text: "#a17ef4" },  // L6

      6: { text: "#dd405d" },  // L7
      7 : {text: "#4ec7dc"}

    };

    return (
      <div key={item.id}>
        <div

          className={`flex items-center px-2 py-1.5 text-sm ${hasChildren ? "cursor-pointer" : "cursor-default"

            }`}

          style={{ paddingLeft: `${8 + level * 16}px` }}

          onClick={() => hasChildren && toggleExpand(item.id)}
        >

          {hasChildren ? (

            isExpanded ? <ChevronDown size={14} className="mr-1" /> : <ChevronRight size={14} className="mr-1" />

          ) : (
            <span className="w-4 inline-block" />

          )}

          {Icon && (
            <Icon

              size={14}

              className="mr-1.5"

              style={{ color: levelColors[level]?.text }}

            />

          )}
          <span>{item.name}</span>

          {item.count && (
            <span className="ml-auto bg-gray-200 px-1.5 py-0.5 rounded-xl text-[11px] text-gray-600">

              {item.count}
            </span>

          )}
        </div>

        {isExpanded && hasChildren && (
          <div>

            {item.children.map(child => renderHierarchyItem(child, level + 1))}
          </div>

        )}
      </div>

    );

  };


  return (
    <>
      <div className="flex h-[calc(100vh-200px)] bg-white">
        {/* Left Sidebar */}
        <div className="w-64 border-r border-gray-200 overflow-y-auto">
          <div className="relative mb-4 mr-[5px]">
            <Search size={14} className="absolute left-2.5 top-2.5 text-gray-400" />
            <input
              type="text"
              placeholder="Search hierarchy..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full py-1.5 pl-5 pr-[4px] border border-gray-300 rounded-md text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            />
          </div>

          <div className="text-[10px] font-semibold text-gray-500 mb-2.5 tracking-wider">
            HIERARCHY LEVELS
          </div>

          <div className="flex gap-1.5 mb-4 flex-wrap">
            <span className="flex items-center gap-1 px-3 py-1 text-[10px] rounded bg-[#e5e0f0]  text-[#a17ef4]">
              <Building2 size={12} className="text-[#a17ef4]" /> L1
            </span>
            <span className="flex items-center gap-1 px-3 py-1 text-[10px] rounded bg-[#dde4f1] text-[#5491f5]">
              <Package size={12}  className="text-[#5491f5]"/> L2
            </span>
            <span className="flex items-center gap-1 px-3 py-1 text-[10px] rounded bg-[#d9e9e5]  text-green-600">
              <Factory size={12} className="text-green-600" /> L3
            </span>
            <span className="flex items-center gap-1 px-3 py-1 text-[10px] rounded bg-[#efe7d9] text-[#f4af3c]">
              <Truck size={12} /> L4
            </span>
            <span className="flex items-center gap-1 px-3 py-1 text-[10px] rounded  rounded bg-[#e5e0f0]  text-[#a17ef4]">
              <Link2 size={12} className="text-[#a17ef4]" /> L5
            </span>
            <span className="flex items-center gap-1 px-3 py-1 text-[10px] rounded bg-[#efdde1]  text-[#dd405d]">
              <Globe size={12} /> L6
            </span>
            <span className="flex items-center gap-1 px-3 py-1 text-[10px] rounded bg-[#d8e9ed] text-[#4ec7dc]">
              <ShoppingBag size={12} /> L7
            </span>
          </div>

          {hierarchyData.map(item => renderHierarchyItem(item))}
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col">
          {/* Header */}
          <div className="flex justify-between px-6 py-4">
            <input
              type="text"
              placeholder="search terms"
              className="w-[300px] mr-3 py-1.5 pl-5 pr-[4px] border border-gray-300 rounded-md text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            />
            <button
              className="bg-[#faf5ff] text-[#be82f9] px-3 py-3"
              onClick={() => setShowAddModal(true)}
            >
              + New
            </button>
          </div>

          <div className="px-6 pb-4 pt-1 border-b border-gray-200">
            <div className="flex justify-between items-center">
              <div>
                <h2 className="text-lg font-semibold text-gray-900">All Terms</h2>
                <p className="text-sm text-gray-500 mt-1">{glossaryTerms.length} terms</p>
              </div>
              <div className="flex gap-2 items-center">
                <button
                  className={`flex items-center px-2.5 py-1.5 border rounded-md ${viewMode === "list"
                    ? "border-gray-600 bg-gray-700 text-white"
                    : "border-gray-300 bg-white text-gray-600"
                    }`}
                  onClick={() => setViewMode("list")}
                >
                  <List size={16} />
                </button>
                
                <button className="flex items-center gap-1.5 px-3 py-1.5 border border-gray-300 bg-white rounded-md text-sm text-black">
                  <span className="text-xs">▼</span> All Status <ChevronDown size={14} />
                </button>
                <button className="flex items-center gap-1.5 px-3 py-1.5 border border-gray-300 bg-white rounded-md text-sm text-black">
                  <span className="text-xs">↕</span> Name <ChevronDown size={14} />
                </button>
              </div>
            </div>
          </div>

          {/* Terms List */}
          <div className="flex-1 overflow-y-auto p-6 bg-gray-50">
            <div className="space-y-3">
              {glossaryTerms.map((term) => (
                <div
                  key={term.id}
                  className="bg-white rounded-lg border border-gray-200 p-5 cursor-pointer hover:shadow-md transition-shadow flex justify-between items-start"
                  onClick={() => setSelectedTerm(term)}
                >
                  {/* Left Side - Term Info */}
                  <div className="flex-1 pr-8">
                    {/* Term Header */}
                    <div className="flex items-center gap-2 mb-3">
                      <h3 className="text-base font-semibold text-black">{term.term}</h3>
                      <CircleCheck size={16} className="text-green-700" />
                      <span className="text-[11px] text-green-700 bg-[#e4eeea] px-2 py-0.5 rounded-full font-medium">
                        {term.status}
                      </span>
                    </div>

                    {/* Definition */}
                    <p className="text-sm text-black leading-relaxed">
                      {term.definition}
                    </p>
                  </div>

                  {/* Right Side - Metadata */}
                  <div className="flex items-center gap-6 text-xs text-black" style={{ minWidth: '380px' }}>
                    {/* Owner */}
                    <div className="flex items-center gap-2" style={{ minWidth: '120px' }}>
                      <div
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          backgroundColor: '#d5d3d8',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '9px',
                          fontWeight: 600,
                          color: '#807992',
                          flexShrink: 0
                        }}
                      >
                        {term.owner?.split(' ').map(n => n[0]).join('').toUpperCase()}
                      </div>
                      <span className="whitespace-nowrap text-[13px]">{term.owner}</span>
                    </div>

                    {/* Classification */}
                    <div className="flex items-center gap-1.5" style={{ minWidth: '100px' }}>
                      <Shield size={12} className="text-[#bb1ccc]" />
                      <span className="whitespace-nowrap text-[13px]">{term.classification}</span>
                    </div>

                    {/* Date */}
                    <div className="flex items-center gap-1.5" style={{ minWidth: '100px' }}>
                      <span><Clock size={12} className="text-amber-500" /></span>
                      <span className="whitespace-nowrap text-[13px]">{term.date}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Modals */}
        {selectedTerm && (
          <ModalPop
            term={selectedTerm}
            onClose={() => setSelectedTerm(null)}
          />
        )}

        {showAddModal && (
          <AddModal
            onClose={() => setShowAddModal(false)}
            onSubmit={handleAddTerm}
          />
        )}
      </div>
    </>
  );
};

export default GlossaryDiscovery;
